/** @format */

import React from 'react';

import {Tooltip} from '@mui/material';

import {StyledHelpIcon, FieldLabel} from './styles';

interface FieldLabelWithHelpProps {
  label: string;
  tooltipText?: string;
}

const FieldLabelWithHelp = ({label, tooltipText}: FieldLabelWithHelpProps) => {
  return (
    <FieldLabel>
      {label}
      {Boolean(tooltipText) && <Tooltip title={tooltipText} arrow placement='top'>
        <StyledHelpIcon/>
      </Tooltip>}
    </FieldLabel>
  );
};

export default FieldLabelWithHelp;
